import { axiosInstance } from "@/lib/axiosInstance";
import axios, { AxiosResponse } from "axios";
import { TransactionStatsResponse } from "../models/transaction.model";



export async function fetchTransactionsStats(): Promise<TransactionStatsResponse> {
  try {
    const res:AxiosResponse = await axiosInstance.get(`/reports/transactions`);
    console.log("dashboard transaction stats", res);
    const data = res.data?.data
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message || "Error fetching transaction stats"
      );
    } else {
      throw new Error("An unknown error occurred");
    }
  }
}
